export const defaultValue = {
    total: 0,
    page: 1,
    limit: 10,
    pages: 1,
    keyword: "",
    approval_status: "1",
  }